import React from "react";

const OrderSkeleton = () => {
  return (
    <>
      {[1, 2, 3].map((i, index) => {
        return <div
          key={index}
          className="bg-dynmaicBg3 mt-2 p-2 rounded-sm animate-pulse"
        >
          {/* Date placeholder */}
          <div className="flex justify-end">
            <div className="h-3 w-24 bg-gray-700 rounded"></div>
          </div>

          {/* Order Food Mappings Skeleton */}
          <div className="space-y-2 mt-2">
            {Array(1)
              .fill(null)
              .map((_, idx) => (
                <div key={idx}>
                  <div className="flex justify-between items-center mb-1">
                    <div className="flex gap-3 items-center">
                      {/* Image Placeholder */}
                      <div className="w-[40px] h-[40px] bg-gray-700 rounded-sm"></div>
                      {/* Text Placeholder */}
                      <div className="flex flex-col gap-1">
                        <div className="h-3 w-32 bg-gray-700 rounded"></div>
                        <div className="h-3 w-20 bg-gray-600 rounded"></div>
                      </div>
                    </div>

                    {/* Price Placeholder */}
                    <div className="h-3 w-12 bg-gray-700 rounded"></div>
                  </div>

                  {/* Divider */}
                  {idx !== 1 && <div className="h-[1px] bg-gray-600"></div>}
                </div>
              ))}
          </div>

          {/* Order Status Placeholder */}
          <div className="flex justify-between items-center capitalize text-xs mt-2">
            <div className="h-3 w-16 bg-gray-700 rounded"></div>
          </div>

          {/* Total Price Placeholder */}
          <div className="flex justify-between items-center mt-2">
            <div className="h-3 w-16 bg-gray-700 rounded"></div>
            <div className="h-3 w-12 bg-gray-600 rounded"></div>
          </div>
        </div>;
      })}
    </>
  );
};

export default OrderSkeleton;
